import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../PageBuilder/models/form-field.model';
import { ChartHeaderElementsEnum } from '../../Charts/models/chart-display-settings.model';
import { ChartDisplayElementModel } from './chart-display-element.model';
import { EntityType } from '../../../api/targeting/enum/entity.type.enum';


export class ChartDisplaySettingsFieldModel implements FormFieldModel {
    property: string;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    label?: string;
    description?: string;
    headerElements?: ChartHeaderElementsEnum[];
    displayPreviousPeriod?: boolean;
    displayTrendIndicators?: boolean;
    displayTrendIndicatorsAppearCondition?: (displayElement: ChartDisplayElementModel) => boolean;
    displayEntityProfile?: EntityType;

    constructor(
        property: string,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        label?: string,
        description?: string,
        headerElements?: ChartHeaderElementsEnum[],
        displayPreviousPeriod?: boolean,
        displayTrendIndicators?: boolean,
        displaytrendIndicatorsAppearCondition?: (displayElement: ChartDisplayElementModel) => boolean,
        displayEntityProfile?: EntityType
    ) {
        this.property = property;
        this.fieldComponent = fieldComponent;
        this.label = label;
        this.description = description;
        this.headerElements = headerElements ?
            headerElements : [ChartHeaderElementsEnum.TITLE, ChartHeaderElementsEnum.DATE, ChartHeaderElementsEnum.SOURCE];
        this.displayPreviousPeriod = displayPreviousPeriod;
        this.displayTrendIndicators = displayTrendIndicators;
        this.displayTrendIndicatorsAppearCondition = displaytrendIndicatorsAppearCondition;
        this.displayEntityProfile = displayEntityProfile;
    }
}

